export const queryFeature = groq`*[_type == "feature" && currentPathname == $currentPathname][0]`;
